// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-summary-page',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        process: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        page: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({
        _isWorking: false
    }),
    computed: {
        getAllPages() {
            let tPages = [];
            {
                this.$forms.getAllPages(tPages, this.schema.pages ?? []);
            }
            return tPages;
        }
    },
    // #endregion
    // #region Core
    methods: {
        onCommand(command, args) {
            //Init
            this._isWorking = true;
            //Run
            this.$emit('command', command, args, () => { this._isWorking = false; });
        },
    },
    // #endregion
});
// #endregion
